import { render, staticRenderFns } from "./DmsDphCalculator.vue?vue&type=template&id=768d80aa&scoped=true&"
import script from "./DmsDphCalculator.vue?vue&type=script&lang=ts&"
export * from "./DmsDphCalculator.vue?vue&type=script&lang=ts&"
import style0 from "./DmsDphCalculator.vue?vue&type=style&index=0&id=768d80aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768d80aa",
  null
  
)

export default component.exports